import {useContext, useEffect, useState} from "react";
import CampGrid from "../Layout/CampGrid";
import Switch from "@mui/material/Switch";
import {Button, ButtonGroup, FormControlLabel} from "@mui/material";
import AuthContext from "../Services/AuthContext";
import {Add, Delete, Edit, List} from "@mui/icons-material";
import Main from "../Layout/Main";
import AddCamp from "../Panel/Camp/AddCamp";
import {createTableColumn} from "@fluentui/react-components";
import EditCamp from "../Panel/Camp/EditCamp";
import {Link, useNavigate} from "react-router-dom";
import SearchBox from "../Component/SearchBox";
import {whitespaceMatcher} from "../Utilities/WhitespaceMatcher";

function UserOrganized() {
    const [user] = useContext(AuthContext);
    const [items, setItems] = useState([]);
    const [archived, setArchived] = useState(false);
    const [camps, setCamps] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [query, setQuery] = useState( '');

    const [addCamp, setAddCamp] = useState(false);
    const [editCamp, setEditCamp] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/camps/organized`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setItems(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);

    useEffect(() => {
        const date = new Date();
        setCamps(items.filter((item) => {
            return (archived || new Date(item.end_date) > date) && whitespaceMatcher(query,
                [item.camp, item.organizer, item.organization, item.season].join(' '))
        }));
    }, [items, archived, query]);
    const columns = [
        createTableColumn ({
            columnId: "registered",
            renderHeaderCell: () => {
                return "Uczestnicy";
            },
            renderCell: (item) => {
                return (<ButtonGroup key={item.id}>
                    <Button variant={'outlined'} color={'success'} title={'Zawarto Umowę'}>{item.paid}</Button>
                    <Button variant={'outlined'} color={'info'} title={'Zapisani'}>{item.confirmed}</Button>
                    <Button variant={'outlined'} color={'warning'} title={'Lista Rezerwowa'}>{item.waiting}</Button>
                    <Button variant={'outlined'} color={'error'} title={'Odrzuceni'}>{item.canceled}</Button>
                    <Button variant={'outlined'} color={'secondary'} title={'Pozostało Miejsc'}>{item.left}</Button>
                </ButtonGroup>);
            }
        }),
        createTableColumn ({
            columnId: "actions",
            renderHeaderCell: () => {
                return "Akcje";
            },
            renderCell: (item) => {
                return (<ButtonGroup key={item.id}>
                    <Button variant={'outlined'} color={'success'} onClick={() => setEditCamp(item)}><Edit /></Button>
                    <Link to={`/camp/${item.id}/list`}><Button variant={'outlined'} color={'info'}><List /></Button></Link>
                    <Button variant={'outlined'} color={'error'} onDoubleClick={() => _delete(item.id)}><Delete /></Button>
                </ButtonGroup>);
            }
        }),
    ];

    function _delete(id) {
        fetch(`/api/camp/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }

    const actions = <>
            <FormControlLabel control={<Switch onChange={() => setArchived(a => !a)} checked={archived} />} label="Archiwalne" />
            <Button variant={'contained'} startIcon={<Add />} onClick={() => setAddCamp(true)}>Dodaj Wydarzenie</Button>
        </>;
    return (
        <Main title={'Wydarzenia'} actions={actions}>
            <SearchBox label={'Wyszukaj po miejscu, organizatorze lub tytule'} query={query} setQuery={setQuery}/>
            <CampGrid items={camps} additionalColumns={columns} />
            <AddCamp data={addCamp} dismiss={() => setAddCamp(false)} onSuccess={() => setRefresh(r => ++r)} />
            <EditCamp data={editCamp} dismiss={() => setEditCamp(false)} onSuccess={() => setRefresh(r => ++r)} />
        </Main>
    );
}

export default UserOrganized;